<template>
  <div>
    <div class="pb-1x">
      <van-swipe :autoplay="5000" indicator-color="white">
        <van-swipe-item v-for="(item, index) in banner" :key="item.key">
          <div class="my-swipe" @click="linkTo(item)">
            <img :src="item.img + '?x-oss-process=style/medium'" alt="" class="res" v-if="index === 0">
            <img :src="item.img" alt="" class="res" v-else>
          </div>
        </van-swipe-item>
      </van-swipe>
      <!--nav功能导航-->
      <ul class="flex-around mt-1x box">
        <li class="text-c" v-for="item in nav" :key="item.key">
          <a :href="item.url" v-if="item.url.includes('tel:')">
            <div class="circle">
              <img :src="item.img" alt="" class="res">
            </div>
            <p class="font-s mt-x">{{ item.name }}</p>
          </a>
          <div v-else @click="linkTo(item)">
            <div class="circle">
              <img :src="item.img" alt="" class="res">
            </div>
            <p class="ft-s mt-x">{{ item.name }}</p>
          </div>
        </li>
      </ul>
      <!--图片网格-->
      <div class="ph-x bg-white" v-if="picture.length">
        <div class="layout1 flex-around mt-1x"
             :class="{'flex-row-r': pictureLayout === 2}"
             v-if="pictureLayout !== 3"
        >
          <div class="left">
            <div class="top">
              <img :src="picture[0].img  + '?x-oss-process=style/medium'" alt="" class="res">
              <div class="dialog" @click="linkTo(picture[0])">
                <h3 class="vertical">{{ picture[0].name }}</h3>
              </div>
            </div>
            <div class="bottom flex-start">
              <div class="img">
                <img :src="picture[1].img  + '?x-oss-process=style/medium'" alt="" class="res">
                <div class="dialog" @click="linkTo(picture[1])">
                  <h3 class="vertical">{{ picture[1].name }}</h3>
                </div>
              </div>
              <div class="img">
                <img :src="picture[2].img  + '?x-oss-process=style/medium'" alt="" class="res">
                <div class="dialog" @click="linkTo(picture[2])">
                  <h3 class="vertical">{{ picture[2].name }}</h3>
                </div>
              </div>
            </div>
          </div>

          <div class="right">
            <div class="img">
              <img :src="picture[3].img  + '?x-oss-process=style/medium'" alt="" class="res">
              <div class="dialog" @click="linkTo(picture[3])">
                <h3 class="vertical">{{ picture[3].name }}</h3>
              </div>
            </div>
            <div class="img">
              <img :src="picture[4].img  + '?x-oss-process=style/medium'" alt="" class="res">
              <div class="dialog" @click="linkTo(picture[4])">
                <h3 class="vertical">{{ picture[4].name }}</h3>
              </div>
            </div>
          </div>
        </div>

        <ul class="layout2 flex-start flex-wrap mt-1x" v-else>
          <li class="item" v-show="index < 4"
              :class="{'mt-x': index > 1}"
              v-for="(item, index) in picture" :key="item.key"
          >
            <img :src="item.img  + '?x-oss-process=style/medium'" alt="" class="res">
            <div class="dialog" @click="linkTo(item)">
              <h3 class="vertical">{{ item.name }}</h3>
            </div>
          </li>
        </ul>
        <!--更多-->
        <ul class="layout2 df flex-wrap" v-show="showMore" v-if="pictureLayout === 3">
          <li class="item" v-show="index >= 4"
              :class="{'mt-x': index > 1}"
              v-for="(item, index) in picture" :key="item.key"
          >
            <img :src="item.img + '?x-oss-process=style/medium'" alt="" class="res">
            <div class="dialog" @click="linkTo(item)">
              <h3 class="vertical">{{ item.name }}</h3>
            </div>
          </li>
        </ul>
        <ul class="layout2 df flex-wrap" v-show="showMore" v-else>
          <li class="item" v-show="index >= 5"
              :class="{'mt-x': index > 1}"
              v-for="(item, index) in picture" :key="item.key"
          >
            <img :src="item.img + '?x-oss-process=style/medium'" alt="" class="res">
            <div class="dialog" @click="linkTo(item)">
              <h3 class="vertical">{{ item.name }}</h3>
            </div>
          </li>
        </ul>
        <!--展示更多-->
        <div class="bg-white primary text-c"
             @click="showMore = !showMore"
             v-if="(pictureLayout !==3 && picture.length > 5) || (pictureLayout ===3 && picture.length > 4)"
        >
          <div class="more">
            <van-icon name="play" size="32" v-show="!showMore" style="transform: rotate(90deg)"/>
            <van-icon name="play" size="32" v-show="showMore" style="transform: rotate(-90deg)"/>
          </div>
        </div>
      </div>
      <!--合作伙伴-->
      <div class="text-c box bd-b mt-1x">—— 合作伙伴 ——</div>
      <section class="flex-around bg-white flex-wrap ph-2x pb-2x">
        <div v-for="item in partner" :key="item.key" class="partner">
          <div class="partner-logo" @click="linkTo(item)">
            <img :src="item.img" alt="" class="res">
          </div>
          <p v-if="item.name" class="text-c ft-s mt-x">{{ item.name }}</p>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
  // import { getHome } from '@/api/getData'
  import wx from 'weixin-js-sdk'

  export default {
  data() {
    return {
      showLoading: true,
      banner: [
        {img: '', url: ''}
      ],
      nav: [
        {img: '', url: '', name: ''},
        {img: '', url: '', name: ''},
        {img: '', url: '', name: ''},
        {img: '', url: '', name: ''},
      ],
      picture: [
        {img: '', url: '', name: ''},
        {img: '', url: '', name: ''},
        {img: '', url: '', name: ''},
        {img: '', url: '', name: ''},
        {img: '', url: '', name: ''},
      ],
      pictureLayout: 1, // 图片网格布局
      partner: [
        {img: '', name: ''}
      ],
      showMore: false,
    }
  },
  created() {
    this.loadHome()
  },
  methods: {
    // 加载首页定制内容
    loadHome() {
      this.$fetch({
        url: '/api/home_page/GetCurHomePage'
      })
        .then(res => {
          if (res) {
            this.banner = res.head_area.detail
            this.nav = res.func_area.detail
            this.picture = res.pic_area.detail
            this.pictureLayout = res.pic_area.layout_mode
            this.partner = res.customer_area.detail
          }
        })
    },
    linkTo(item) {
      let url = item.url
      if (url.includes('http')) {
        // 如果是跳转会员系统
        if (url.includes('https://p.sglsd.com/member_mobile/')) {
          const token = localStorage.getItem('hotel_token')
          let homeSrc = encodeURIComponent(`${location.origin}${location.pathname}`)
          url += `?memberId=${localStorage.getItem('openId')}&a=${localStorage.getItem('appId')}&t=${localStorage.getItem('server')}&homeSrc=${homeSrc}&token=${token}`
        }
        location.href = url
      }
      else if (this.isJSON(url)){
        // {"latitude": 23.106470, "longitude": 113.324460, "name": "广州塔", "address": "广东省广州市海珠区阅江西路222号"}
        // 打开微信内置地图
        const { latitude, longitude, name, address } = JSON.parse(url)
        wx.openLocation({
          latitude, // 纬度，浮点数，范围为90 ~ -90
          longitude, // 经度，浮点数，范围为180 ~ -180。
          name, // 位置名
          address, // 地址详情说明
          scale: 16, // 地图缩放级别,整形值,范围从1~28。默认为最大
          infoUrl: '' // 在查看位置界面底部显示的超链接,可点击跳转
        })
      }
      else {
        this.$router.push(url)
      }
    },
    isJSON(str) {
      try {
        return typeof JSON.parse(str) === 'object'
      }
      catch(e) {
        console.log(e)
        return  false
      }
    }
  }
}
</script>

<style lang="less" scoped>
  /*轮播*/
  .my-swipe {
    height: 50vw;
    overflow: hidden;
    background: #fff;
  }
  .circle{
    margin: 0 auto;
    width: 40px;
    height: 40px;
    text-align: center;
    overflow: hidden;
  }
  /*图片网格区域布局1*/
  .layout1{
    div{
      overflow: hidden;
    }
    .left{
      .top{
        position: relative;
        width: calc(50vw - 8px);
        height: calc((50vw - 8px) / 3);
      }
      .bottom{
        margin-top: 4px;
        .img{
          position: relative;
          width: calc((50vw - 12px) / 2);
          height: calc((50vw - 12px) / 1.5);
        }
        .img:first-child{
          margin-right: 4px;
        }
      }
    }
    .right {
      .img{
        position: relative;
        width: calc(50vw - 8px);
        height: calc((50vw - 8px) / 2);
      }
      .img:last-child{
        margin-top: 4px;
      }
    }
  }
  /*图片网格区域布局3*/
  .layout2{
    background: #fff;
    .item{
      position: relative;
      width: calc((100vw - 12px) / 2);
      height: calc(25vw - 12px);
      overflow: hidden;
      &:nth-of-type(odd) {
        margin-right: 4px;
      }
    }
  }
  .dialog{
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    /*background: rgba(0,0,0,0.4);*/
    .vertical{
      /*width:100%;*/
      text-align: right;
      padding: 0 5px;
      background: rgba(0,0,0,0.4);
      position: absolute;
      /*top: 50%;*/
      /*left: 50%;*/
      bottom: 0;
      right: 0;
      /*transform: translate(-50%, -50%);*/
      color: #fff;
    }
  }
  .activity-img{
    width: 80px;
    height: 80px;
    overflow: hidden;
  }

  @keyframes move {
    100% {
      transform: translateY(4px);
    }
  }
  .more{
    animation: move 1s linear infinite;
  }

  /*合作伙伴*/
  .partner{
    margin-top: 16px;
    .partner-logo{
      width: calc((100vw - 64px) / 3);
      height: calc((100vw - 64px) / 3);
      /*background: #eee;*/
      border-radius: 8px;
      overflow: hidden;
    }
  }
  .res{
    height:100%;
  }
</style>


